import React from 'react';
import { FormattedMessage } from '@99designs/frontend-components/i18n';
import Currency from './Currency';
import type { Currency as CurrencyCode } from '../../../shared/lib/currency';

interface Props {
    string: string;
    fromPriceValue: number;
    toPriceValue: number;
    currency: CurrencyCode;
    hideDecimal?: boolean;
}

export const CurrencyRange = ({
    string,
    fromPriceValue,
    toPriceValue,
    currency,
    hideDecimal = false,
}: Props) => {
    return (
        <FormattedMessage
            message={string}
            values={{
                fromPrice: (
                    <Currency
                        value={fromPriceValue}
                        currency={currency}
                        hideDecimal={hideDecimal}
                    />
                ),
                toPrice: (
                    <Currency value={toPriceValue} currency={currency} hideDecimal={hideDecimal} />
                ),
            }}
        />
    );
};
